import { css } from '@/styled-system/css';

export const propertyCardMLSLogoStyles = css.raw({
  'display': 'grid',
  'gridArea': 'mls-logo',
  'justifyItems': 'end',
  'paddingBlock': 'PropertyCard.PhotoFooter.logo.padding.vert',
  'paddingInline': 'PropertyCard.PhotoFooter.logo.padding.horz',

  '& img, & picture': {
    maxBlockSize: 'PropertyCard.PhotoFooter.logo.maxHeight',
    maxInlineSize: 'PropertyCard.PhotoFooter.logo.maxWidth',
  },
});
